export const chartsStrings = {
  HEB: {
    // Dashboard Menu
    actions: "פעולות",
    edit: "ערוך",
    cancel: "בטל",
    restoreDefaults: "שחזר ברירת מחדל",
    save: "שמור",
    removeChart: "הסר תרשים",
    addChart: "הוסף תרשים",
    hiddenCharts: "תרשימים מוסתרים",
    addAllHiddenCharts: "הוסף הכל",
    generatingReport: "יוצר דוח",
    reportStepPreparing: "מכין דוח",
    reportStepLoadingPage: "טוען דף הדוח",
    reportStepRendering: "מעבד את הדוח",
    reportStepGeneratingPdf: "יוצר קובץ PDF",
    uploadingMasleka: "מעלה ומעבד קובץ מסלקה",
    downloadingMasleka: "מוריד קובץ מסלקה",
    generateFinancialReport: "צור דוח ריכוז מידע פיננסי",
    sendReportByEmail: "שלח דוח פיננסי במייל",
    sendReportByEmailSending: "שולח...",
    sendReportByEmailSuccess: "הדוח נשלח לכתובת המייל שלך.",
    sendReportByEmailError: "השליחה נכשלה. נסה שוב.",
    sendReportByEmailMissingEmail: "לא נמצאה כתובת המייל שלך.",
    uploadMaslekaZip: "העלה קובץ מסלקה (ZIP)",
    downloadMasleka: "הורד קובץ מסלקה",
    unsupportedInApp: "פעולה זו אינה נתמכת באפליקציה",
    unsupportedInAppDesc:
      "הורדת קבצים ויצירת דוחות זמינות רק דרך מחשב, או דרך דפדפן Chrome בטלפון.",
    understood: "הבנתי",
    reportOptionsTitle: "התאמת הדוח הפיננסי",
    reportOptionsDescription: "בחר מה לכלול בדוח",
    reportOptionsGenerate: "צור דוח",
    reportOptionsSelectAll: "בחר הכל",
    reportOptionsClearAll: "נקה הכל",
    reportSectionPortfolio: "דוח התיק (סקירה, פנסיה, תובנות, נכסים)",
    reportSectionOverview: "סקירת תיק (נכסים, נזילות, פילוח)",
    reportSectionPension: "לוח פנסיה",
    reportSectionInsights: "תובנות",
    reportSectionTable: "טבלת נכסים מרכזת",
    reportSectionAssets: "פירוט נכסים",
    reportSectionInsurance: "ביטוח",
    reportSectionCashflow: "תזרים מזומנים",
    reportAssetTypePension: "פנסיה",
    reportAssetTypeBank: "עו\"ש ופיקדונות",
    reportAssetTypeCreditcard: "כרטיסי אשראי",
    reportAssetTypeShare: "מניות",
    reportAssetTypeRsu: "RSU",
    reportAssetTypeCrypto: "קריפטו",
    reportAssetTypeRealestate: "נדל\"ן",
    reportAssetTypeDebt: "התחייבויות",
    reportAssetTypeOther: "אחר",
    reportCashflowMonthsLabel: "טווח חודשים לתזרים",
    reportCashflowMonthsOption: "{n} חודשים אחרונים",
    missingPersonalDetails:
      "חסרים פרטים אישיים. האם תרצה לעדכן אותם כעת?",
    missingIdNumber:
      "חסר מספר תעודת זהות. האם תרצה לעדכן את הפרטים האישיים כעת?",
    uploadZipOnly: "יש להעלות קובץ ZIP בלבד",
    maslekaUploadSuccess: "קובץ המסלקה הועלה ועובד בהצלחה!",
    maslekaUploadError: "שגיאה בהעלאת קובץ המסלקה. אנא נסה שוב.",
    maslekaEncryptedZipError:
      "קובץ ה-ZIP מוצפן ולא ניתן לפתוח אותו. ודא שהסיסמה נכונה ונסה שוב.",
    maslekaFileTooLarge:
      "קובץ ה-ZIP גדול מדי. יש להעלות קובץ עד 25MB.",
    maslekaNoDataFound:
      "לא נמצאו בקובץ נתוני מסלקה תקינים. ודא שהעלית את קובץ המסלקה הנכון.",
    maslekaUploadModalTitle: "העלאת קובץ מסלקה",
    maslekaUploadModalDescription:
      "אם קובץ המסלקה מוצפן בסיסמה, הזן את הסיסמה שקיבלת מספק הקובץ.",
    maslekaPasswordLabel: "סיסמת הקובץ (אם קיימת)",
    maslekaPasswordHint:
      "הסיסמה היא בדרך כלל 4 הספרות האחרונות של כרטיס האשראי שאיתו ביצעת את המסלקה.",
    maslekaPasswordShow: "הצג סיסמה",
    maslekaPasswordHide: "הסתר סיסמה",
    maslekaPasswordRequired: "יש להזין את סיסמת הקובץ.",
    maslekaIdNumberDetectedLabel: "מספר תעודת זהות מהקובץ",
    maslekaFilenameUnreadable:
      "לא הצלחנו לזהות את מספר תעודת הזהות מתוך שם הקובץ. ודא שהקובץ הוא קובץ מסלקה תקין.",
    maslekaIdNumberExists:
      "מספר תעודת הזהות שזוהה בקובץ כבר קיים אצל משתמש אחר במערכת. לא ניתן לשייך אותו לחשבון זה.",
    maslekaInvalidZipPassword:
      "לא ניתן לפתוח את קובץ ה-ZIP עם הסיסמה שהוזנה. אנא ודא שהסיסמה נכונה ונסה שוב.",
    maslekaIdChangeWarningTitle: "שינוי מספר תעודת זהות",
    maslekaIdChangeWarningBody:
      "כבר מקושר לחשבון מספר תעודת זהות שונה ויש נתוני מסלקה קיימים. העלאת הקובץ תחליף את מספר תעודת הזהות ואת נתוני המסלקה הקיימים. פעולה זו אינה הפיכה.",
    maslekaIdChangeConfirmCheckbox: "אני מבין/ה ומאשר/ת את השינוי",
    maslekaUploadConfirm: "המשך והעלה",

    // Markets Data
    marketsDataTitle: "נתוני שוק",
    bankOfIsraelInterest: "ריבית בנק ישראל",
    inflation: "אינפלציה",
    lastUpdateValue: "שווי לפי עדכון אחרון",
    last12Months: "ב12 החודשים האחרונים",
    euroRate: "שער היורו",
    usdRate: "שער הדולר",
    btcRate: "שער הביטקוין",
    period1w: "שבוע",
    period1m: "חודש",
    period3m: "3 חודשים",
    marketsCustomize: "התאמה אישית",
    marketsEdit: "עריכה",
    marketsAddAsset: "הוספת מדד או מטבע",
    marketsPresets: "מדדים ומטבעות",
    marketsRemovedSection: "מדדים ומטבעות שהוסרו",
    marketsAddItem: "חיפוש",
    marketsSearchPlaceholder: "חיפוש מטבע, מניה או קריפטו",
    marketsNoData: "אין מספיק נתונים",
    marketsRemove: "הסרה",
    marketsDrag: "גרירה לסידור",
    marketsMoveStart: "הזזה להתחלה",
    marketsMoveEnd: "הזזה לסוף",
    marketsTypeFiat: "מטבע",
    marketsTypeCrypto: "קריפטו",
    marketsTypeStock: "מניה",
    marketsTypeStat: "נתון",
    marketsDone: "סיום",
    marketsEmpty: "לא נוספו פריטים",
    marketsResults: "תוצאות",

    // Liquidity Chart
    liquidMoney: "כסף נזיל",
    nonLiquidMoney: "כסף לא נזיל",
    availableImmediately: "כסף זמין מיידית",
    liquidityLabel: "(נזילות)",
    relevantOpportunities: "הזדמנויות רלוונטיות עבורך:",

    // Portfolio Worth
    portfolioWorthHeader: "שווי התיק שלך ",
    totalAssets: "נכסים",
    totalDebts: "התחייבויות",
    totalNetWorth: "שווי נטו ",
    relativeToDate: "ביחס לנתונים מ",
    atTime: "בשעה",

    // Historic Worth graph (modal and extras beyond historicWorthText)
    manageHistoryData: "ניהול נתוני היסטוריה",
    sortByLabel: "מיון לפי:",
    sortDate: "תאריך",
    sortAssets: "נכסים",
    sortDebts: "התחייבויות",
    sortNetWorth: "שווי נטו",
    actionsColumn: "פעולות",
    historicWorthPremiumLock:
      "הצגת שווי היסטורי לאורך זמן זמינה רק למנויי פרימיום",
    tooltipDate: "תאריך:",
    historicWorthCurrentPoint: "נתונים נוכחיים",
    viewChangeDetails24h: "צפה בפרטי השינוי ב-24 השעות האחרונות",
    announcement24hTitle: "חדש",
    announcement24hBody: "לחצו על אחוז השינוי למטה (למשל +0.38%) כדי לראות פירוט שינוי ב-24 השעות.",
    announcement24hGotIt: "הבנתי",

    // Historic Worth Analysis Tab
    tabGraph: "גרף",
    tabAnalysis: "ניתוח",
    resolutionLabel: "רזולוציה",
    resolutionDaily: "יומי",
    resolutionWeekly: "שבועי",
    resolutionMonthly: "חודשי",
    resolutionQuarterly: "רבעוני",
    period24h: "24 שעות",
    period30d: "30 יום",
    period90d: "90 יום",
    period6m: "6 חודשים",
    period1y: "שנה",
    periodAll: "הכל",
    periodCustom: "מותאם",
    analysisNetWorth: "שווי נטו",
    analysisAssets: "נכסים",
    analysisDebts: "התחייבויות",
    analysisBestCategory: "קטגוריה מובילה",
    analysisChange: "שינוי",
    analysisStartValue: "ערך התחלתי",
    analysisEndValue: "ערך סופי",
    analysisChangeAmount: "שינוי (₪)",
    analysisChangePercent: "שינוי (%)",
    analysisCategory: "קטגוריה",
    analysisCategoryPerformance: "ביצועי קטגוריות",
    analysisNoData: "אין מספיק נתונים לניתוח בתקופה זו",
    analysisCustomRange: "בחירת טווח תאריכים",
    monthlyNetWorthTitle: "שווי נטו חודשי",
    downloadAnalysisReport: "הורד דוח",
    generatingAnalysisReport: "מייצר דוח...",

    // Report empty state
    reportNoDataForPeriod: "אין נתונים ל־{n} הימים האחרונים",

    // Currency Chart
    noDataToDisplay: "אין נתונים להצגה",
    moreItems: "נוספים",

    // Sunburst extras
    selectLabel: "בחר",
    categoryWord: "קטגוריה",
    resetLabel: "איפוס",
    cashLabel: " מזומן",

    // Personal Details
    financialSummaryReport: "דו״ח ריכוז מידע פיננסי",
    createdOnDate: "נוצר בתאריך:",

    // Cashflow Time Selection
    selectDates: "בחירת תאריכים",
    selectDateRange: "בחירת טווח תאריכים",
    fromDate: "מתאריך",
    toDate: "עד תאריך",
    confirm: "אישור",
    noPeriodSelected: "לא נבחר תקופה",
    until: "עד",
    close: "סגור",

    // Transaction Explanation
    transactionActionsTitle: "פעולות שניתן לבצע על עסקאות:",
    clickOnCategory: "לחיצה על קטגוריה",
    clickOnCategoryDesc:
      "פותחת תפריט לשינוי הקטגוריה של העסקה הספציפית",
    example: "דוגמה:",
    clickToChangeCategory: "← לחץ כאן לשינוי קטגוריה",
    clickOnEye: "לחיצה על העין 👁️",
    clickOnEyeDesc:
      "מתעלמת מהעסקה - לא נספרת בסיכומים הכוללים",
    normalState: "רגיל:",
    ignoringState: "מתעלם:",
    createRule: "יצירת כלל",
    createRuleDesc: "חל על כל העסקאות שמכילות את המחרוזת הזאת",
    hasRule: "יש כלל:",
    markAsInvestmentLabel: "סימון כהשקעה 📈",
    markAsInvestmentDesc:
      'העסקה מסומנת כהשקעה. אפשר עדיין לראות אותה אבל היא לא נספרת בסיכום ההוצאות ונכללת בסיכום ההשקעות. משנה קטגוריה רק כאשר העסקה מסומנת כ״לא מסווג״',
    investmentLabel: "השקעה",
    stocksLabel: "מניות",
    markedAsInvestment: "← מסומן כהשקעה",
    tipTitle: "💡 טיפ:",
    tipContent:
      "השתמש בכלל כדי לחסוך זמן - במקום לשנות קטגוריה לכל עסקה בנפרד, צור כלל שיחול אוטומטית על עסקאות דומות",
    autoRulesTitle: "🔄 כללים אוטומטיים:",
    autoRulesContent:
      'כשיוצרים כלל, הוא חל על כל העסקאות הקיימות והעתידיות שמכילות את הטקסט המוגדר. לדוגמה: כלל עבור "סופר" ישפיע על כל עסקה שמכילה את המילה "סופר"',
    foodCategory: "מזון",

    // Button titles
    deleteAction: "מחיקה",

    // Error messages
    reportGenerationError: "שגיאה ביצירת הדוח",
    maslekaFileDownloadError: "שגיאה בהורדת קובץ המסלקה",
    maslekaFileUploadError: "שגיאה בהעלאת קובץ המסלקה",
    unknownError: "שגיאה לא ידועה",
    editPremiumOnly: "עריכה זמינה רק למנויי פרימיום",

    // Currency display names
    currencyILS: "שקל",
    currencyUSD: "דולר",
    currencyEUR: "יורו",
    currencyGBP: "פאונד",
    currencyCHF: "פרנק שוויצרי",
    currencyJPY: "ין יפני",
    currencyCAD: "דולר קנדי",
    currencyAUD: "דולר אוסטרלי",
    currencyCrypto: "קריפטו",
  },
  ENG: {
    // Dashboard Menu
    actions: "Actions",
    edit: "Edit",
    cancel: "Cancel",
    restoreDefaults: "Restore defaults",
    save: "Save",
    removeChart: "Remove chart",
    addChart: "Add chart",
    hiddenCharts: "Hidden charts",
    addAllHiddenCharts: "Add all",
    generatingReport: "Generating report",
    reportStepPreparing: "Preparing report",
    reportStepLoadingPage: "Loading report page",
    reportStepRendering: "Rendering report",
    reportStepGeneratingPdf: "Generating PDF",
    uploadingMasleka: "Uploading and processing Masleka file",
    downloadingMasleka: "Downloading Masleka file",
    generateFinancialReport: "Generate financial summary report",
    sendReportByEmail: "Send financial report by mail",
    sendReportByEmailSending: "Sending...",
    sendReportByEmailSuccess: "Report sent to your email.",
    sendReportByEmailError: "Failed to send. Please try again.",
    sendReportByEmailMissingEmail: "Your email address was not found.",
    uploadMaslekaZip: "Upload Masleka file (ZIP)",
    downloadMasleka: "Download Masleka file",
    unsupportedInApp: "This action is not supported in the app",
    unsupportedInAppDesc:
      "Downloading files and generating reports is only available on a computer, or through Chrome browser on mobile.",
    understood: "Got it",
    reportOptionsTitle: "Customize financial report",
    reportOptionsDescription: "Choose what to include in the report",
    reportOptionsGenerate: "Generate report",
    reportOptionsSelectAll: "Select all",
    reportOptionsClearAll: "Clear all",
    reportSectionPortfolio: "Portfolio report (overview, pension, insights, assets)",
    reportSectionOverview: "Portfolio overview (assets, liquidity, breakdown)",
    reportSectionPension: "Pension dashboard",
    reportSectionInsights: "Insights",
    reportSectionTable: "Assets summary table",
    reportSectionAssets: "Asset details",
    reportSectionInsurance: "Insurance",
    reportSectionCashflow: "Cashflow",
    reportAssetTypePension: "Pension",
    reportAssetTypeBank: "Bank & deposits",
    reportAssetTypeCreditcard: "Credit cards",
    reportAssetTypeShare: "Stocks",
    reportAssetTypeRsu: "RSU",
    reportAssetTypeCrypto: "Crypto",
    reportAssetTypeRealestate: "Real estate",
    reportAssetTypeDebt: "Debts",
    reportAssetTypeOther: "Other",
    reportCashflowMonthsLabel: "Cashflow months range",
    reportCashflowMonthsOption: "Last {n} months",
    missingPersonalDetails:
      "Personal details are missing. Would you like to update them now?",
    missingIdNumber:
      "ID number is missing. Would you like to update your personal details now?",
    uploadZipOnly: "Only ZIP files can be uploaded",
    maslekaUploadSuccess:
      "Masleka file uploaded and processed successfully!",
    maslekaUploadError:
      "Error uploading Masleka file. Please try again.",
    maslekaEncryptedZipError:
      "The ZIP file is encrypted and could not be opened. Verify the password and try again.",
    maslekaFileTooLarge:
      "The ZIP file is too large. Please upload a file up to 25MB.",
    maslekaNoDataFound:
      "No valid Masleka data was found in the ZIP. Make sure you uploaded the correct Masleka file.",
    maslekaUploadModalTitle: "Upload Masleka file",
    maslekaUploadModalDescription:
      "If the Masleka file is password-protected, enter the password you received from the file provider.",
    maslekaPasswordLabel: "File password (if any)",
    maslekaPasswordHint:
      "The password is usually the last 4 digits of the credit card you used to order the Masleka.",
    maslekaPasswordShow: "Show password",
    maslekaPasswordHide: "Hide password",
    maslekaPasswordRequired: "Please enter the file password.",
    maslekaIdNumberDetectedLabel: "ID number from file",
    maslekaFilenameUnreadable:
      "We couldn't detect an ID number in the file name. Make sure this is a valid Masleka file.",
    maslekaIdNumberExists:
      "The ID number detected in the file already belongs to another user. It cannot be assigned to this account.",
    maslekaInvalidZipPassword:
      "Could not open the ZIP file with the provided password. Please verify the password and try again.",
    maslekaIdChangeWarningTitle: "Changing the ID number",
    maslekaIdChangeWarningBody:
      "A different ID number is already linked to this account and existing Masleka data is on record. Uploading this file will replace the ID number and the existing data. This action cannot be undone.",
    maslekaIdChangeConfirmCheckbox: "I understand and approve the change",
    maslekaUploadConfirm: "Continue & upload",

    // Markets Data
    marketsDataTitle: "Market Data",
    bankOfIsraelInterest: "Bank of Israel interest rate",
    inflation: "Inflation",
    lastUpdateValue: "Value as of last update",
    last12Months: "In the last 12 months",
    euroRate: "Euro rate",
    usdRate: "USD rate",
    btcRate: "Bitcoin rate",
    period1w: "1W",
    period1m: "1M",
    period3m: "3M",
    marketsCustomize: "Customize",
    marketsEdit: "Edit",
    marketsAddAsset: "Add index or currency",
    marketsPresets: "Indexes & currencies",
    marketsRemovedSection: "Removed indexes & currencies",
    marketsAddItem: "Search",
    marketsSearchPlaceholder: "Search currency, stock or crypto",
    marketsNoData: "Not enough data",
    marketsRemove: "Remove",
    marketsDrag: "Drag to reorder",
    marketsMoveStart: "Move to start",
    marketsMoveEnd: "Move to end",
    marketsTypeFiat: "Currency",
    marketsTypeCrypto: "Crypto",
    marketsTypeStock: "Stock",
    marketsTypeStat: "Indicator",
    marketsDone: "Done",
    marketsEmpty: "No items added",
    marketsResults: "Results",

    // Liquidity Chart
    liquidMoney: "Liquid funds",
    nonLiquidMoney: "Non-liquid funds",
    availableImmediately: "Immediately available",
    liquidityLabel: "(Liquidity)",
    relevantOpportunities: "Relevant opportunities for you:",

    // Portfolio Worth
    portfolioWorthHeader: "Your portfolio value ",
    totalAssets: "Assets",
    totalDebts: "Liabilities",
    totalNetWorth: "Net worth ",
    relativeToDate: "Relative to data from",
    atTime: "at",

    // Historic Worth graph (modal and extras)
    manageHistoryData: "Manage data",
    sortByLabel: "Sort by:",
    sortDate: "Date",
    sortAssets: "Assets",
    sortDebts: "Liabilities",
    sortNetWorth: "Net worth",
    actionsColumn: "Actions",
    historicWorthPremiumLock:
      "Viewing historic worth over time is available for Premium subscribers only",
    tooltipDate: "Date:",
    historicWorthCurrentPoint: "Current data",
    viewChangeDetails24h: "View change details for the last 24 hours",
    announcement24hTitle: "New",
    announcement24hBody: "Click the percentage change below (e.g. +0.38%) to see the 24-hour change breakdown.",
    announcement24hGotIt: "Got it",

    // Historic Worth Analysis Tab
    tabGraph: "Graph",
    tabAnalysis: "Analysis",
    resolutionLabel: "Resolution",
    resolutionDaily: "Daily",
    resolutionWeekly: "Weekly",
    resolutionMonthly: "Monthly",
    resolutionQuarterly: "Quarterly",
    period24h: "24h",
    period30d: "30D",
    period90d: "90D",
    period6m: "6M",
    period1y: "1Y",
    periodAll: "All",
    periodCustom: "Custom",
    analysisNetWorth: "Net Worth",
    analysisAssets: "Assets",
    analysisDebts: "Liabilities",
    analysisBestCategory: "Top Category",
    analysisChange: "Change",
    analysisStartValue: "Start Value",
    analysisEndValue: "End Value",
    analysisChangeAmount: "Change",
    analysisChangePercent: "Change (%)",
    analysisCategory: "Category",
    analysisCategoryPerformance: "Category Performance",
    analysisNoData: "Not enough data to analyze for this period",
    analysisCustomRange: "Select date range",
    monthlyNetWorthTitle: "Monthly Net Worth",
    downloadAnalysisReport: "Download Report",
    generatingAnalysisReport: "Generating report...",

    // Report empty state
    reportNoDataForPeriod: "No data for the last {n} days",

    // Currency Chart
    noDataToDisplay: "No data to display",
    moreItems: "more",

    // Sunburst extras
    selectLabel: "Select",
    categoryWord: "category",
    resetLabel: "Reset",
    cashLabel: " Cash",

    // Personal Details
    financialSummaryReport: "Financial Summary Report",
    createdOnDate: "Created on:",

    // Cashflow Time Selection
    selectDates: "Select dates",
    selectDateRange: "Select date range",
    fromDate: "From date",
    toDate: "To date",
    confirm: "Confirm",
    noPeriodSelected: "No period selected",
    until: "to",
    close: "Close",

    // Transaction Explanation
    transactionActionsTitle:
      "Actions you can perform on transactions:",
    clickOnCategory: "Click on a category",
    clickOnCategoryDesc:
      "Opens a menu to change the specific transaction's category",
    example: "Example:",
    clickToChangeCategory: "← Click here to change category",
    clickOnEye: "Click on the eye 👁️",
    clickOnEyeDesc:
      "Ignores the transaction — not counted in totals",
    normalState: "Normal:",
    ignoringState: "Ignoring:",
    createRule: "Create a rule",
    createRuleDesc:
      "Applies to all transactions containing this text",
    hasRule: "Has rule:",
    markAsInvestmentLabel: "Mark as investment 📈",
    markAsInvestmentDesc:
      "The transaction is marked as an investment. It can still be viewed but is not counted in expenses and is included in the investments summary. Category only changes when the transaction is marked as 'Not classified'",
    investmentLabel: "Investment",
    stocksLabel: "Stocks",
    markedAsInvestment: "← Marked as investment",
    tipTitle: "💡 Tip:",
    tipContent:
      "Use rules to save time — instead of changing the category for each transaction separately, create a rule that automatically applies to similar transactions",
    autoRulesTitle: "🔄 Automatic rules:",
    autoRulesContent:
      'When you create a rule, it applies to all existing and future transactions containing the defined text. For example: a rule for "supermarket" will affect every transaction containing the word "supermarket"',
    foodCategory: "Food",

    // Button titles
    deleteAction: "Delete",

    // Error messages
    reportGenerationError: "Error generating report",
    maslekaFileDownloadError: "Error downloading Masleka file",
    maslekaFileUploadError: "Error uploading Masleka file",
    unknownError: "Unknown error",
    editPremiumOnly: "Editing available for Premium subscribers only",

    // Currency display names
    currencyILS: "ILS",
    currencyUSD: "USD",
    currencyEUR: "EUR",
    currencyGBP: "GBP",
    currencyCHF: "CHF",
    currencyJPY: "JPY",
    currencyCAD: "CAD",
    currencyAUD: "AUD",
    currencyCrypto: "Crypto",
  },
  RUS: {
    // Dashboard Menu
    actions: "Действия",
    edit: "Редактировать",
    cancel: "Отмена",
    restoreDefaults: "Восстановить по умолчанию",
    save: "Сохранить",
    removeChart: "Удалить график",
    addChart: "Добавить график",
    hiddenCharts: "Скрытые графики",
    addAllHiddenCharts: "Добавить все",
    generatingReport: "Создание отчёта",
    reportStepPreparing: "Подготовка отчёта",
    reportStepLoadingPage: "Загрузка страницы отчёта",
    reportStepRendering: "Обработка отчёта",
    reportStepGeneratingPdf: "Создание PDF",
    uploadingMasleka: "Загрузка и обработка файла Маслеки",
    downloadingMasleka: "Скачивание файла Маслеки",
    generateFinancialReport: "Создать финансовый сводный отчёт",
    sendReportByEmail: "Отправить финансовый отчёт по email",
    sendReportByEmailSending: "Отправка...",
    sendReportByEmailSuccess: "Отчёт отправлен на ваш email.",
    sendReportByEmailError: "Не удалось отправить. Попробуйте ещё раз.",
    sendReportByEmailMissingEmail: "Ваш адрес электронной почты не найден.",
    uploadMaslekaZip: "Загрузить файл Маслеки (ZIP)",
    downloadMasleka: "Скачать файл Маслеки",
    unsupportedInApp: "Это действие не поддерживается в приложении",
    unsupportedInAppDesc:
      "Скачивание файлов и создание отчётов доступно только на компьютере или через браузер Chrome на мобильном устройстве.",
    understood: "Понятно",
    reportOptionsTitle: "Настройка финансового отчёта",
    reportOptionsDescription: "Выберите, что включить в отчёт",
    reportOptionsGenerate: "Создать отчёт",
    reportOptionsSelectAll: "Выбрать всё",
    reportOptionsClearAll: "Очистить всё",
    reportSectionPortfolio: "Отчёт по портфелю (обзор, пенсия, инсайты, активы)",
    reportSectionOverview: "Обзор портфеля (активы, ликвидность, разбивка)",
    reportSectionPension: "Пенсионная панель",
    reportSectionInsights: "Инсайты",
    reportSectionTable: "Сводная таблица активов",
    reportSectionAssets: "Детализация активов",
    reportSectionInsurance: "Страхование",
    reportSectionCashflow: "Денежный поток",
    reportAssetTypePension: "Пенсия",
    reportAssetTypeBank: "Счета и депозиты",
    reportAssetTypeCreditcard: "Кредитные карты",
    reportAssetTypeShare: "Акции",
    reportAssetTypeRsu: "RSU",
    reportAssetTypeCrypto: "Крипто",
    reportAssetTypeRealestate: "Недвижимость",
    reportAssetTypeDebt: "Обязательства",
    reportAssetTypeOther: "Прочее",
    reportCashflowMonthsLabel: "Диапазон месяцев денежного потока",
    reportCashflowMonthsOption: "Последние {n} мес.",
    missingPersonalDetails:
      "Отсутствуют личные данные. Хотите обновить их сейчас?",
    missingIdNumber:
      "Отсутствует номер удостоверения личности. Хотите обновить личные данные сейчас?",
    uploadZipOnly: "Можно загрузить только ZIP-файлы",
    maslekaUploadSuccess:
      "Файл Маслеки загружен и обработан успешно!",
    maslekaUploadError:
      "Ошибка при загрузке файла Маслеки. Попробуйте ещё раз.",
    maslekaEncryptedZipError:
      "ZIP-файл зашифрован и не может быть открыт. Проверьте пароль и попробуйте ещё раз.",
    maslekaFileTooLarge:
      "ZIP-файл слишком большой. Загрузите файл размером до 25MB.",
    maslekaNoDataFound:
      "В ZIP-файле не найдены корректные данные Маслеки. Убедитесь, что загружен правильный файл.",
    maslekaUploadModalTitle: "Загрузка файла Маслеки",
    maslekaUploadModalDescription:
      "Если файл Маслеки защищён паролем, введите пароль, который вы получили от поставщика файла.",
    maslekaPasswordLabel: "Пароль файла (если есть)",
    maslekaPasswordHint:
      "Обычно пароль — это последние 4 цифры кредитной карты, с которой вы заказывали Маслеку.",
    maslekaPasswordShow: "Показать пароль",
    maslekaPasswordHide: "Скрыть пароль",
    maslekaPasswordRequired: "Введите пароль файла.",
    maslekaIdNumberDetectedLabel: "Номер удостоверения из файла",
    maslekaFilenameUnreadable:
      "Не удалось определить номер удостоверения по имени файла. Убедитесь, что это корректный файл Маслеки.",
    maslekaIdNumberExists:
      "Номер удостоверения, найденный в файле, уже принадлежит другому пользователю и не может быть привязан к этой учётной записи.",
    maslekaInvalidZipPassword:
      "Не удалось открыть ZIP-файл с указанным паролем. Проверьте пароль и попробуйте ещё раз.",
    maslekaIdChangeWarningTitle: "Изменение номера удостоверения",
    maslekaIdChangeWarningBody:
      "К аккаунту уже привязан другой номер удостоверения и есть существующие данные Маслеки. Загрузка файла заменит номер удостоверения и существующие данные. Действие необратимо.",
    maslekaIdChangeConfirmCheckbox: "Я понимаю и подтверждаю изменение",
    maslekaUploadConfirm: "Продолжить и загрузить",

    // Markets Data
    marketsDataTitle: "Рыночные данные",
    bankOfIsraelInterest: "Ставка Банка Израиля",
    inflation: "Инфляция",
    lastUpdateValue: "Стоимость по последнему обновлению",
    last12Months: "За последние 12 месяцев",
    euroRate: "Курс евро",
    usdRate: "Курс доллара",
    btcRate: "Курс биткоина",
    period1w: "1Н",
    period1m: "1М",
    period3m: "3М",
    marketsCustomize: "Настроить",
    marketsEdit: "Редактировать",
    marketsAddAsset: "Добавить индекс или валюту",
    marketsPresets: "Индексы и валюты",
    marketsRemovedSection: "Удалённые индексы и валюты",
    marketsAddItem: "Поиск",
    marketsSearchPlaceholder: "Поиск валюты, акции или крипто",
    marketsNoData: "Недостаточно данных",
    marketsRemove: "Удалить",
    marketsDrag: "Перетащите для сортировки",
    marketsMoveStart: "В начало",
    marketsMoveEnd: "В конец",
    marketsTypeFiat: "Валюта",
    marketsTypeCrypto: "Крипто",
    marketsTypeStock: "Акция",
    marketsTypeStat: "Показатель",
    marketsDone: "Готово",
    marketsEmpty: "Нет добавленных элементов",
    marketsResults: "Результаты",

    // Liquidity Chart
    liquidMoney: "Ликвидные средства",
    nonLiquidMoney: "Неликвидные средства",
    availableImmediately: "Доступно немедленно",
    liquidityLabel: "(Ликвидность)",
    relevantOpportunities: "Актуальные возможности для вас:",

    // Portfolio Worth
    portfolioWorthHeader: "Стоимость вашего портфеля ",
    totalAssets: "Активы",
    totalDebts: "Обязательства",
    totalNetWorth: "Чистая стоимость ",
    relativeToDate: "По отношению к данным от",
    atTime: "в",

    // Historic Worth graph (modal and extras)
    manageHistoryData: "Управление данными",
    sortByLabel: "Сортировка:",
    sortDate: "Дата",
    sortAssets: "Активы",
    sortDebts: "Обязательства",
    sortNetWorth: "Чистая стоимость",
    actionsColumn: "Действия",
    historicWorthPremiumLock:
      "Отображение исторической стоимости доступно только для подписчиков Премиум",
    tooltipDate: "Дата:",
    historicWorthCurrentPoint: "Текущие данные",
    viewChangeDetails24h: "Просмотреть детали изменений за последние 24 часа",
    announcement24hTitle: "Новое",
    announcement24hBody: "Нажмите на процент изменения ниже (напр. +0.38%), чтобы увидеть разбивку изменений за 24 часа.",
    announcement24hGotIt: "Понятно",

    // Historic Worth Analysis Tab
    tabGraph: "График",
    tabAnalysis: "Анализ",
    resolutionLabel: "Разрешение",
    resolutionDaily: "Ежедневно",
    resolutionWeekly: "Еженедельно",
    resolutionMonthly: "Ежемесячно",
    resolutionQuarterly: "Ежеквартально",
    period24h: "24ч",
    period30d: "30д",
    period90d: "90д",
    period6m: "6м",
    period1y: "1г",
    periodAll: "Все",
    periodCustom: "Произв.",
    analysisNetWorth: "Чистая стоимость",
    analysisAssets: "Активы",
    analysisDebts: "Обязательства",
    analysisBestCategory: "Лучшая категория",
    analysisChange: "Изменение",
    analysisStartValue: "Начальная стоимость",
    analysisEndValue: "Конечная стоимость",
    analysisChangeAmount: "Изменение",
    analysisChangePercent: "Изменение (%)",
    analysisCategory: "Категория",
    analysisCategoryPerformance: "Показатели категорий",
    analysisNoData: "Недостаточно данных для анализа за этот период",
    analysisCustomRange: "Выбрать диапазон дат",
    monthlyNetWorthTitle: "Ежемесячная чистая стоимость",
    downloadAnalysisReport: "Скачать отчёт",
    generatingAnalysisReport: "Создание отчёта...",

    // Report empty state
    reportNoDataForPeriod: "Нет данных за последние {n} дней",

    // Currency Chart
    noDataToDisplay: "Нет данных для отображения",
    moreItems: "ещё",

    // Sunburst extras
    selectLabel: "Выбрать",
    categoryWord: "категория",
    resetLabel: "Сброс",
    cashLabel: " Наличные",

    // Personal Details
    financialSummaryReport: "Финансовый сводный отчёт",
    createdOnDate: "Создан:",

    // Cashflow Time Selection
    selectDates: "Выбрать даты",
    selectDateRange: "Выбрать диапазон дат",
    fromDate: "С даты",
    toDate: "По дату",
    confirm: "Подтвердить",
    noPeriodSelected: "Период не выбран",
    until: "до",
    close: "Закрыть",

    // Transaction Explanation
    transactionActionsTitle:
      "Действия, которые можно выполнить с транзакциями:",
    clickOnCategory: "Нажмите на категорию",
    clickOnCategoryDesc:
      "Открывает меню для изменения категории конкретной транзакции",
    example: "Пример:",
    clickToChangeCategory: "← Нажмите здесь для смены категории",
    clickOnEye: "Нажмите на глаз 👁️",
    clickOnEyeDesc:
      "Игнорирует транзакцию — не учитывается в итогах",
    normalState: "Обычный:",
    ignoringState: "Игнорируется:",
    createRule: "Создать правило",
    createRuleDesc:
      "Применяется ко всем транзакциям, содержащим этот текст",
    hasRule: "Есть правило:",
    markAsInvestmentLabel: "Отметить как инвестицию 📈",
    markAsInvestmentDesc:
      "Транзакция отмечена как инвестиция. Её можно просматривать, но она не учитывается в расходах и включена в сводку инвестиций. Категория меняется только если транзакция отмечена как «Не классифицировано»",
    investmentLabel: "Инвестиция",
    stocksLabel: "Акции",
    markedAsInvestment: "← Отмечено как инвестиция",
    tipTitle: "💡 Совет:",
    tipContent:
      "Используйте правила для экономии времени — вместо изменения категории для каждой транзакции отдельно создайте правило, которое автоматически применяется к похожим транзакциям",
    autoRulesTitle: "🔄 Автоматические правила:",
    autoRulesContent:
      'При создании правила оно применяется ко всем существующим и будущим транзакциям, содержащим указанный текст. Например: правило для «супермаркет» повлияет на каждую транзакцию, содержащую слово «супермаркет»',
    foodCategory: "Еда",

    // Button titles
    deleteAction: "Удалить",

    // Error messages
    reportGenerationError: "Ошибка при создании отчёта",
    maslekaFileDownloadError: "Ошибка при скачивании файла Маслеки",
    maslekaFileUploadError: "Ошибка при загрузке файла Маслеки",
    unknownError: "Неизвестная ошибка",
    editPremiumOnly: "Редактирование доступно только для подписчиков Премиум",

    // Currency display names
    currencyILS: "Шекель",
    currencyUSD: "Доллар",
    currencyEUR: "Евро",
    currencyGBP: "Фунт",
    currencyCHF: "Швейцарский франк",
    currencyJPY: "Японская иена",
    currencyCAD: "Канадский доллар",
    currencyAUD: "Австралийский доллар",
    currencyCrypto: "Крипто",
  },
} as const;
